import React from "react";
import {  useSelector } from "react-redux";
import HeaderAddButton from "./headerAddButton";
import "./style.css";
import { FEATURE_TOGGLE_ADD_NEW_DEADLINES } from "../../../config";
import { useNavigate } from "react-router-dom";

const PageHeader = ({
  image,
  title,
  subtitle,
  isDocumentsPage,
  isFoldersPage,
  isFulfilmentPage,
  isPermissionWebUpload,
  isPermissionStudioUpload,
  isPermissionCreateFolders,
  tooltip,  
  onClick
}) => {
  const main = useSelector(state => state.main);
  const navigate = useNavigate();
  return (
    <div
      className="headerOuterContainer"
      style={{ padding: isFoldersPage ? "32px" : "16px" }}
    >
      <div className="headerImgContainer">
        <img src={image} alt="" />
      </div>
      <div className="headerDescriptionButtonContainer">
        <div className="headerDescriptionContainer">
          <div>
            <h3 className="headerDescriptionTitle">{title}</h3>
            <h5 className="headerDescriptionSubtitle">{subtitle}</h5>
          </div>
        </div>
      </div>
      {isDocumentsPage ? (
        (isPermissionWebUpload && main.myType !== "STUDIO") ||
        (isPermissionStudioUpload && main.myType === "STUDIO") ? (
            <div className="headerButtonContainer">
              <HeaderAddButton isDocumentsButton={true} navigate={navigate} />
            </div>
          ) : null
      ) : (FEATURE_TOGGLE_ADD_NEW_DEADLINES === "true" &&
          !isFoldersPage &&
          !isFulfilmentPage) ||
        (isFoldersPage && isPermissionCreateFolders) ? (
          <div className="headerButtonContainer">
            {main.myType === "STUDIO" && (
              <HeaderAddButton
                navigate={navigate}
                onClick={onClick}
                isFolderButton={isFoldersPage}
                tooltip={tooltip}
              />
            )}
          </div>
        ) : (
          isFulfilmentPage && (
            <div className="headerButtonContainer">
              {/* <Button
                  kind={"primary"}
                >
                  <FormattedMessage id="fulfilments.driverButton" />
                </Button>*/}
            </div>
          )
        )}
    </div>
  );
};

export default PageHeader;
